/** 주소검색(우편번호검색)을 통해 주소만 선택 후 닫는 케이스 (외부에 공개된 우편번호검색) */
export const SELECT_ADDRESS_SUBTYPE = {
    /** 일반 케이스 */
    SELECT_ADDRESS_NORMAL: 'SELECT_ADDRESS_NORMAL',
}
export type SelectAddressSubtype = Constant<typeof SELECT_ADDRESS_SUBTYPE>

/** 배송지정보(주소+연락처+배송지명 등)를 선택하는 케이스 세부 케이스 */
export const SELECT_DELIVERY_ADDRESS_SUBTYPE = {
    /** 일반 케이스 */
    SELECT_DELIVERY_ADDRESS_NORMAL: 'SELECT_DELIVERY_ADDRESS_NORMAL',
    /** 일반 케이스 (선택된 주소 해시 없음) */
    SELECT_DELIVERY_ADDRESS_NO_HASH: 'SELECT_DELIVERY_ADDRESS_NO_HASH',
    /** 배송지가 없어서 최초로 배송지를 등록하는 케이스 */
    ADD_FIRST_ADDRESS: 'ADD_FIRST_ADDRESS',
    /** 주소검색(우편번호검색)을 통해 주소 선택 시 이전 오류주소를 기반으로 선택하는 케이스. (주문서 > 오류주소 정정을 위한 배송지변경창 오픈) */
    CORRECT_INVALID_DELIVERY_ADDRESS: 'CORRECT_INVALID_DELIVERY_ADDRESS',
}
export type SelectDeliveryAddressSubtype = Constant<typeof SELECT_DELIVERY_ADDRESS_SUBTYPE>

/** 배송지정보(주소+연락처+배송지명+메모)를 선택하는 케이스 세부 케이스 */
export const SELECT_DELIVERY_INFO_SUBTYPE = {
    /** 일반 케이스 */
    SELECT_DELIVERY_INFO_NORMAL: 'SELECT_DELIVERY_INFO_NORMAL',
    /** 메모영역이 우선노출되는 케이스 (주문상세/주문완료 > 메모상세모달 > 메모변경하기로 진입) */
    SHOW_MEMO_FIRST: 'SHOW_MEMO_FIRST',
    /** 연락처만 변경하는 케이스 (주문상세/주문완료 > 도착보장상품 > 연락처만변경가능 안내모달로 진입) */
    CHANGE_CONTACT_ONLY: 'CHANGE_CONTACT_ONLY',
}
export type SelectDeliveryInfoSubtype = Constant<typeof SELECT_DELIVERY_INFO_SUBTYPE>

/**
 * 참고)
 *  scene: 현재 노출되는 컴포넌트를 결정하기 위한 locationState에 저장되는 데이터.
 *  type: 배송지변경창이 리턴할 내용, 각종 action 분기처리를 위한 데이터
 * */
/** 배송지관리 타입 */
export const DELIVERY_MANAGER_TYPE = {
    ...SELECT_ADDRESS_SUBTYPE,
    ...SELECT_DELIVERY_ADDRESS_SUBTYPE,
    ...SELECT_DELIVERY_INFO_SUBTYPE,
} as const
export type DeliveryManagerType = Constant<typeof DELIVERY_MANAGER_TYPE>

export const DEFAULT_DELIVERY_MANAGER_TYPE = SELECT_ADDRESS_SUBTYPE.SELECT_ADDRESS_NORMAL

// 배송지변경창 단계
export const DELIVERY_MANAGER_STEP = {
    IDLE: 'IDLE',
    APPLYING: 'APPLYING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
} as const
export type DeliveryManagerStep = Constant<typeof DELIVERY_MANAGER_STEP>

/**
 * 히스토리카운트를 배송지변경창 진입 시부터 쌓아야 하는 케이스
 * - 주소검색 상세주소 폼 화면, 배송지수정화면에서 확인/닫기버튼 클릭 시 진입점으로 되돌아가야 함
 * */
export const closeDeliveryManagerWithFormConfirmTypes = [
    DELIVERY_MANAGER_TYPE.SELECT_ADDRESS_NORMAL,
    DELIVERY_MANAGER_TYPE.ADD_FIRST_ADDRESS,
    DELIVERY_MANAGER_TYPE.CORRECT_INVALID_DELIVERY_ADDRESS,
    DELIVERY_MANAGER_TYPE.CHANGE_CONTACT_ONLY,
]

/** 주문 후 주문 배송지정보를 변경하는 케이스 */
export const changeDeliveryInfoCase = [
    DELIVERY_MANAGER_TYPE.CHANGE_CONTACT_ONLY,
    DELIVERY_MANAGER_TYPE.SELECT_DELIVERY_INFO_NORMAL,
    DELIVERY_MANAGER_TYPE.SHOW_MEMO_FIRST,
]

/** 배송지변경창 초기화 시 주문정보 조회 api 결과를 초기스토어에 반영해야 하는 케이스 */
export const shouldFetchOrderInfoTypes = changeDeliveryInfoCase

/** 최초 진입 화면이 배송지리스트인 케이스 (주문서, 상세/완료에서 진입) */
export const initWithDeliveryAddressListCase = [
    DELIVERY_MANAGER_TYPE.SELECT_DELIVERY_ADDRESS_NORMAL,
    DELIVERY_MANAGER_TYPE.SELECT_DELIVERY_ADDRESS_NO_HASH,
    DELIVERY_MANAGER_TYPE.SELECT_DELIVERY_INFO_NORMAL,
    DELIVERY_MANAGER_TYPE.SHOW_MEMO_FIRST,
]

/** 최초 진입 화면이 우편번호검색인 케이스 (주문서에서 진입) */
export const initWithAddressSearchCase = [
    DELIVERY_MANAGER_TYPE.ADD_FIRST_ADDRESS,
    DELIVERY_MANAGER_TYPE.CORRECT_INVALID_DELIVERY_ADDRESS,
]
